import { connect } from "react-redux";
import { ApplicationState } from "store";
import {
    actionCreators,
    getCalendar,
    getBorderImageId,
} from "page/calendar/store";
import { BorderGallery } from "./border-gallery";
import { getBorderOptions } from "burde-api-content/store";
import { actionCreators as eventActionCreators } from "event/store";

const mapStateToProps = (state: ApplicationState) => ({
    borderImageId: getBorderImageId(state),
    calendar: getCalendar(state),
    borderOptions: getBorderOptions(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...eventActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(BorderGallery);
